import { render, staticRenderFns } from "./ProductGrid.vue?vue&type=template&id=3e726be2&scoped=true&"
import script from "./ProductGrid.vue?vue&type=script&lang=js&"
export * from "./ProductGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProductGrid.vue?vue&type=style&index=0&id=3e726be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e726be2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e726be2')) {
      api.createRecord('3e726be2', component.options)
    } else {
      api.reload('3e726be2', component.options)
    }
    module.hot.accept("./ProductGrid.vue?vue&type=template&id=3e726be2&scoped=true&", function () {
      api.rerender('3e726be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/ProductGrid.vue"
export default component.exports